export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '收货地址列表';